var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUser = function SvgIconUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f8f9fa",
    fillRule: "evenodd",
    d: "M15 .333a8.334 8.334 0 1 0 .002 16.666A8.334 8.334 0 0 0 15 .333zm-5 8.333a5 5 0 1 1 10 0 5 5 0 1 1-10 0zM8.333 20.333A8.334 8.334 0 0 0 0 28.667V32a1.667 1.667 0 0 0 3.333 0v-3.333a5 5 0 0 1 5-5h13.333a5 5 0 0 1 5 5V32A1.667 1.667 0 0 0 30 32v-3.333a8.33 8.33 0 0 0-8.334-8.333H8.333z"
  })));
};
export default SvgIconUser;